import { FLUSS_NODE_TYPES } from "modules/fluss/utils/bpmn";

type PopupEntries = Record<string, any>;
let scriptAuthorAllowed = true;
export const setFlussPopupScriptPermission = (allowed: boolean) => { scriptAuthorAllowed = allowed; };

// The third-party popup hides these executable Primum types with rank -1.
// Keep this list tied to FLUSS_NODE_TYPES, not to the whole BPMN catalog.
export const FLUSS_POPUP_UNHIDDEN_ENTRY_IDS = [
    "inclusive-gateway", // FLUSS_NODE_TYPES.inclusiveGateway
    "send-task", // FLUSS_NODE_TYPES.sendTask
    "manual-task", // FLUSS_NODE_TYPES.manualTask
] as const;

const FLUSS_POPUP_UNHIDDEN_TYPES = new Set<string>([
    FLUSS_NODE_TYPES.inclusiveGateway,
    FLUSS_NODE_TYPES.sendTask,
    FLUSS_NODE_TYPES.manualTask,
]);

// diagram-js merges providers in event order, so lower-than-default priority runs later and wins.
export const FLUSS_POPUP_OVERRIDE_PRIORITY = 500;

export const createPopupRankUpdater = (prefix: "create" | "append") => (entries: PopupEntries) => {
    let updated = scriptAuthorAllowed ? entries : Object.fromEntries(
        Object.entries(entries).filter(([id]) => !id.includes("script-task"))
    );

    FLUSS_POPUP_UNHIDDEN_ENTRY_IDS.forEach((actionName) => {
        const id = `${prefix}-${actionName}`;
        const entry = updated[id];
        if (!entry) return;

        updated = updated === entries ? { ...entries } : updated;
        updated[id] = { ...entry, rank: 0 };
    });

    return updated;
};

export function FlussPopupRankProvider(this: any, popupMenu: any) {
    this.getPopupMenuEntries = () => createPopupRankUpdater("create");
    popupMenu.registerProvider("bpmn-create", FLUSS_POPUP_OVERRIDE_PRIORITY, this);

    popupMenu.registerProvider("bpmn-append", FLUSS_POPUP_OVERRIDE_PRIORITY, {
        getPopupMenuEntries: () => createPopupRankUpdater("append"),
    });
    popupMenu.registerProvider("bpmn-replace", FLUSS_POPUP_OVERRIDE_PRIORITY, {
        getPopupMenuEntries: () => (entries: PopupEntries) => scriptAuthorAllowed ? entries :
            Object.fromEntries(Object.entries(entries).filter(([id]) => !id.includes("script-task"))),
    });
}

(FlussPopupRankProvider as any).$inject = ["popupMenu"];

export const flussPopupRankModule = {
    __init__: ["flussPopupRankProvider"],
    flussPopupRankProvider: ["type", FlussPopupRankProvider],
};

export const isFlussPopupUnhiddenType = (type: string) => FLUSS_POPUP_UNHIDDEN_TYPES.has(type);
